import React from 'react';
import Logo from '../assets/favicon.jpeg';
import { LogOut, ShoppingBag } from 'lucide-react';

const CustomerHome: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
  return (
    <div style={{ minHeight: '100vh', background: '#f8f7f5', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif", padding: '24px' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');`}</style>
      <div style={{ textAlign: 'center', maxWidth: '360px' }}>
        <img src={Logo} alt="Logo" style={{ width: '64px', height: '64px', borderRadius: '16px', objectFit: 'cover', marginBottom: '20px' }} />
        <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: '#fff5f2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
          <ShoppingBag size={24} color="#F1561D" />
        </div>
        <h1 style={{ margin: '0 0 8px', fontSize: '22px', fontWeight: 600, color: '#111827' }}>Welcome back!</h1>
        <p style={{ margin: '0 0 32px', fontSize: '14px', color: '#9ca3af', lineHeight: 1.6 }}>You're signed in to Scan Pay Go. Use the mobile app to start scanning and paying.</p>
        <button onClick={onLogout}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '10px 24px', fontSize: '14px', fontWeight: 500, color: '#374151', cursor: 'pointer' }}>
          <LogOut size={16} color="#9ca3af" /> Sign out
        </button>
      </div>
    </div>
  );
};

export default CustomerHome;